var exports = {
  "O3": "xae11d333--ca9109--underground",
  "or": "xae11d333--ca9109--underground-icon",
  "qj": "xae11d333--ca9109--underground-text",
  "SA": "xae11d333--ca9109--underground-time",
};

module.exports = exports;
